<template>
  <div>
    <h4>自然科</h4>
    <h5>3-4年級自然實驗課程</h5>
    <ul>
      <li class="check">全新齊全的實驗室設備。</li>
      <li class="check">每位學生都有一套實驗器材，可自己動手做實驗。</li>
      <li class="check">先教原理，再親自做實驗，記憶最深刻。</li>
      <li class="check">老師從旁協助，解決你的困惑，注意你的安全。</li>
    </ul>
    <p>
      自然實驗課讓小朋友提早接觸到自然科學的奧妙，在親手操作、親自觀察之下對大自然的了解更加深刻，未來在學習自然科時觸類旁通，學得更快更好！
    </p>
    <p>
      <b>每年二月底</b>舉辦3-5年級高僑盃競試，高僑盃的成績可作為自然科分班依據。如果沒有參加到高僑盃競試，或對高僑盃成績不滿意，約兩週後會舉辦團體甄試（請密切注意！）兩者成績擇優入班。
      <b>無論成績如何都至少可參加5-6年級自然班課程。</b>而在班就讀期間，複習考表現優良同學也可以再往上提升到更高難度的課程唷！
    </p>
    <h5>
      5-6年級
    </h5>
    <p>
      除曉明以外的私中入學測驗都會考自然科，未來希望往私立國中邁進的同學們千萬別忘了準備自然科！
    </p>
    <ul>
      <li>
        自然班－私中的自然科考試內容不是難，而是廣，甚至有些學校沒有教。學生們若沒有經過老師統整，要把這麼多的內容融會貫通是困難的，讓自然班老師幫你歸納整理內容、熟悉考題解法吧！
      </li>
      <br />
      <li>
        拔尖班（甄試入班）－數理科未來都相對重要，未來希望考上衛道科學班、明道拔尖班的同學們，自然科絕對是關鍵！拔尖班教學的難度絕對足夠你考這些特殊班！
      </li>
    </ul>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/scss/course.scss";
</style>
